import { node, string, bool, oneOf } from 'prop-types'
import { Component } from 'react'
import { kuiperClassNames, renderIcon } from '../../utils'

import './styles.scss'

export default class TogglePane extends Component {
  static propTypes = {
    children: node,
    className: string,
    header: node,
    open: bool,
    popoverId: string,
    shouldValidate: bool,
    startOpen: bool,
    theme: oneOf(['light', 'dark']),
    valid: bool,
  }

  static defaultProps = {
    shouldValidate: false,
    startOpen: false,
    theme: 'dark',
  }

  constructor(props) {
    super(props)

    this.state = { open: this.props.startOpen }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.startOpen !== this.props.startOpen && !this.state.open) {
      this.toggle()
    }
  }

  get open() {
    return this.state.open === undefined ? this.props.open : this.state.open
  }

  toggle() {
    this.setState({
      open: !this.open,
    })
  }

  get toggleLabel() {
    const setName = this.props.header?.props?.children
    const validity = this.props.valid ? 'valid' : 'invalid'
    return `${setName} label set toggle ${validity}`
  }

  get toggler() {
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        onClick={this.toggle.bind(this)}
        tabIndex="0"
        role="button"
        aria-label={this.toggleLabel}
        aria-controls={this.props.popoverId}
        aria-expanded={this.open}
        aria-haspopup="true"
      >
        <span className={kuiperClassNames('toggler')}>
          {renderIcon('triangle-sm-e', {
            ariaLabel: 'Toggle',
            ariaMode: 'presentational',
          })}
        </span>
        {this.props.header}
      </div>
    )
  }

  render() {
    const { children, className, shouldValidate, theme, valid } = this.props
    const { open } = this
    const classes = {
      open,
      valid,
      validate: shouldValidate,
    }
    return (
      <div
        className={kuiperClassNames('toggle-pane', className, classes, theme)}
      >
        {this.toggler}
        <section>
          <div className={kuiperClassNames('content')}>{children}</div>
        </section>
      </div>
    )
  }
}
